import * as Sentry from "@sentry/browser";
import { createLogger } from '../../utils/logger';

const { debugLog, captureError, captureMessage } = createLogger(Sentry, 'browser-sdk');

export { debugLog, captureError, captureMessage };
